module.exports = __webpack_public_path__ + "static/media/img_header_document_search_mobile.9c8826c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/assets/img_header_document_search_mobile.jpg
// module id = 252
// module chunks = 1